import { Button, ButtonGroup, DialogBody, DialogFooter, Stack, Text } from "@chakra-ui/react";
import { UI } from "components";
import { toaster } from "config";
import { API } from "config";
import useOrder from "hooks/useOrder";
import { useState } from "react";

export default function Approve({ data = {}, ...props }){

    const order = useOrder(data?.id)
    const [ loading, setLoading ] = useState(false)

    const handleApprove = async () => {
        if(!window.confirm('Tem certeza que deseja aprovar este pedido?')) return
        setLoading(true)

        try{
            await API.put(`/orders/${order?.data?.id}/approve`)
            toaster.create({ title: 'O pedido foi aprovado', type: 'success' })
            order.refetch()
            props.onClose()
        }catch(err){
            toaster.create({ title: 'Não foi possível aprovar o pedido', description: err?.response?.data?.message, type: 'warning' })
        }

        setLoading(false)
    }

    return(
    <UI.Dialog loading={loading} size="sm" title={`Aprovar pedido #${order.data?.cod}?`} {...props}>
        <DialogBody>
            <Stack gap={3}>
                <Text fontSize="sm">A aprovação de um pedido é uma ação irreversível. No momento da aprovação, os pagamentos pendentes (exceto de terceiros e bônus) serão confirmados e o status do pedido passará a ser <b>Aprovado</b>.</Text>
                <Text>Pontuação e bonificação referente a este pedido serão distribuídas para a rede.</Text>
                <Text>Tem certeza que deseja prosseguir com a aprovação?</Text>
            </Stack>
        </DialogBody>
        <DialogFooter>
            <ButtonGroup>
                <Button loading={loading} loadingText="Aprovando pedido..." variant="subtle" colorPalette="green" onClick={handleApprove}><UI.Icon name="done" /> Aprovar pedido</Button>
                <Button disabled={loading} variant="ghost" onClick={props.onClose}>Fechar</Button>
            </ButtonGroup>
        </DialogFooter>
    </UI.Dialog>
    )    
}